//@ts-check
import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import request from "../../../utils/request";
import Button from "../../../core/Button";
import useProvider from "../../../core/EcrionProvider/useProvider";
import Modals from "../../../modal";
import LinkFormatter from "../../../formatter/Link";
import useLicense from "../../Licensing/useLicense";
import FragmentContainer from "./FragmentContainer";

var SubscriptionsSettingsFragment = function SubscriptionsSettingsFragment() {
  var _useProvider = useProvider(),
      routes = _useProvider.routes;

  var history = routes && routes.history;
  return React.createElement(FragmentContainer, {
    title: "Subscriptions"
  }, React.createElement(Typography, {
    gutterBottom: true
  }, "Configure the subscriptions used by the emails."), React.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    alignContent: "space-between",
    spacing: 1
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Button, {
    onClick: function onClick() {
      return history.push('/settings/subscriptions');
    }
  }, "Configure Subscriptions"))));
};

SubscriptionsSettingsFragment.defaultProps = {};
export default SubscriptionsSettingsFragment;